import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-salary-grid',
  templateUrl: './salary-grid.component.html',
  styleUrls: ['./salary-grid.component.css']
})
export class SalaryGridComponent implements OnInit {

  title="View Salary";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/master/salary/salary-grid/salary-grid.component.ts